import { useDetailsGridsEvent, useGridEvent } from 'components/shared/data/DataGrid/hooks';
import { CountSelectedProps } from 'components/shared/data/DataGrid/StatusPanel/CountSelected/CountSelected.types';
import { getSelectedRowsForMasterNodes } from 'components/shared/data/DataGrid/utils/masterDetailsHelpers';
import { useTranslator } from 'components/shared/hooks';
import React, { ReactElement, useCallback, useEffect, useState } from 'react';

// Helper to count detail grids using the official API
const countDetailGrids = (gridApi: any): number => {
  let count = 0;
  gridApi.forEachDetailGridInfo(() => count++);
  return count;
};

export const CountSelectedInDetails = ({ api, title, context }: CountSelectedProps): ReactElement => {
  const [count, setCount] = useState(0);
  const trans = useTranslator();
  const [detailsGridsCount, setDetailsGridsCount] = useState(0);

  const updateValue = useCallback(
    (gridApi: any) => {
      setTimeout(() => {
        const rows = getSelectedRowsForMasterNodes(gridApi.getSelectedNodes(), context.detailsMapping);
        setCount(rows.length);
      });
    },
    [context.detailsMapping],
  );

  useGridEvent(api, 'modelUpdated', ({ api: gridApi }) => {
    setDetailsGridsCount(countDetailGrids(gridApi));
    updateValue(gridApi);
  });

  useGridEvent(api, 'paginationChanged', ({ api: gridApi }) => {
    setDetailsGridsCount(countDetailGrids(gridApi));
    updateValue(gridApi);
  });

  useGridEvent(api, 'selectionChanged', ({ api: gridApi }) => {
    setDetailsGridsCount(countDetailGrids(gridApi));
    updateValue(gridApi);
  });

  useEffect(() => {
    updateValue(api);
  }, [api, detailsGridsCount, updateValue]);

  useDetailsGridsEvent(api, 'selectionChanged', () => updateValue(api), [api, detailsGridsCount]);

  useDetailsGridsEvent(api, 'paginationChanged', () => updateValue(api), [api, detailsGridsCount]);

  useDetailsGridsEvent(api, 'modelUpdated', () => updateValue(api), [api, detailsGridsCount]);

  return (
    <div className="ag-name-value">{count === 0 ? '' : trans(title || 'COMMON.SELECTED_N_RESULTS', { count })}</div>
  );
};
